// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT DIRECTLY.

import Paging from "./Paging";
import Survey from "entity/Survey";
import SurveyAnswer from "entity/SurveyAnswer";

import { RestController, RestRequest } from "./RestController";

export default class SurveyController extends RestController {

    getSurvey(surveyId: number): Promise<Survey> {
        const request = new RestRequest("/api/v1/survey/" + surveyId + "", "GET", null, undefined);
        return this.request(request, null) as Promise<Survey>;
    }

    getSurveys(page?: Paging): Promise<Survey[]> {
        const request = new RestRequest("/api/v1/survey", "GET", null, undefined);
        if (page) request.addPaging("", page);

        return this.request(request, null) as Promise<Survey[]>;
    }

    submitAnswer(answer: SurveyAnswer): Promise<void> {
        const request = new RestRequest("/api/v1/survey/answer", "POST", answer, undefined);
        return this.requestVoid(request);
    }

}
